(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/overview/sign-separators.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/overview/sign-separators.js');
"use strict";


const styles = {
  base: {
    display: 'inline-block',
    fontSize: '12px',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
  },
  separator: {
    padding: '0 1px'
  }
};
function getSum(drawEvents) {
  const sum = drawEvents.filter(selection => selection === true).length;
  if (sum === 0) {
    return 1;
  }
  return sum;
}
const SignSeparators = _ref => {
  let {
    drawEvents,
    rowPrice
  } = _ref;
  const items = [];
  let key = 0;
  drawEvents.forEach((drawEvent, index) => {
    if (index === 0) {
      return;
    }
    items.push(getSum(drawEvent));
    if (index !== drawEvents.length - 1) {
      items.push( React.createElement("span", {
        key: key,
        style: styles.separator
      }, ' ', "x", ' '));
    }
    key += 1;
  });
  items.push( React.createElement("span", {
    key: key,
    style: styles.separator
  }, ' ', "x", ' '));
  items.push( React.createElement("strong", {
    key: key + 1
  }, rowPrice));
  return React.createElement("div", {
    style: styles.base
  }, items);
};
SignSeparators.defaultProps = {
  drawEvents: []
};
svs.challenge.SignSeparators = SignSeparators;

 })(window);